import { useMemo } from 'react'
import { Button, HStack, VStack } from '@chakra-ui/react'
import NavBar from 'components/NavBar'
import { useSelector } from 'model/hooks'
import { IEntityType, NodeDataT } from 'shared/types'
import { AddIcon } from '@chakra-ui/icons'
import { dbCreateCourse } from 'controllers/courses'
import { useNavigate } from 'react-router-dom'
import FileThree from 'components/FileThree'
import { NodeModel } from '@minoru/react-dnd-treeview'
import { dbUpdateFileTree } from 'controllers/fileThree'
import _ from 'lodash'

const Courses = () => {
  const navigate = useNavigate()
  const courses = useSelector(state => state.courses)
  const fileThreeDBData = useSelector(state => state.fileTree)

  const treeData = useMemo(() => {
    const dbTreeRaw = _.get(fileThreeDBData, IEntityType.COURSES, [])
    const dbTree = _.map(dbTreeRaw, el => {
      if (el.data && el.data.id) {
        const c = _.get(courses, el.data.id)
        if (c) {
          return { ...el, text: _.get(c, 'title', 'unnamed') }
        } else {
          return null
        }
      } else {
        return el
      }
    })
    const res = _.compact(dbTree)
    const dbTreeDict = _.keyBy(dbTree, 'id')
    _.forEach(courses, c => {
      if (!_.has(dbTreeDict, c.id)) {
        const n: NodeModel<NodeDataT> = {
          id: c.id,
          parent: 'root',
          text: c.title,
          droppable: false,
          data: {
            id: c.id
          }
        }
        res.push(n)
      }
    })
    return res
  }, [fileThreeDBData, courses])

  const onChangeFileTree = (treeData: NodeModel<NodeDataT>[]) => {
    dbUpdateFileTree(IEntityType.COURSES, treeData)
  }

  const onCreateCourseClick = async () => {
    const courseId = await dbCreateCourse()
    navigate(`/courses/${courseId}`)
  }

  const navBarActions = (
    <HStack>
      <Button
        colorScheme='teal'
        leftIcon={<AddIcon />}
        onClick={onCreateCourseClick}
      >
        Создать курс
      </Button>
    </HStack>
  )

  return (
    <VStack w='full' h='full' spacing={0}>
      <NavBar hideBackButton title='Курсы'>
        {navBarActions}
      </NavBar>
      <VStack align={'center'} w='full' h='full' p={4} overflowY={'auto'}>
        <VStack maxW='4xl' w='full'>
          <FileThree
            treeData={treeData}
            onChange={onChangeFileTree}
            onNodeClick={id => navigate(`/${IEntityType.COURSES}/${id}`)}
          />
        </VStack>
      </VStack>
    </VStack>
  )
}

export default Courses
